<template>
  <article
    class="bg-white rounded-lg shadow-[0px_4px_30px_0px_#0000004D] w-full pointer-events-auto group"
    @click="$emit('click-location', $event, location)">
    <div v-if="location.image" class="relative h-32 md:h-48 bg-theme-30">
      <Image :image="location.image" class="rounded-t-lg w-full" sizes="360px" />
      <Button
        variant="theme"
        size="square"
        class="absolute top-2 right-2"
        aria-label="Sluit popup"
        @click.stop="$emit('close')">
        <CloseIcon class="w-3 h-3" />
      </Button>
    </div>
    <div v-else class="relative h-8">
      <Button
        variant="theme"
        size="square"
        class="absolute top-2 right-2"
        aria-label="Sluit popup"
        @click.stop="$emit('close')">
        <CloseIcon class="w-3 h-3" />
      </Button>
    </div>
    <Transition
      enter-active-class="transition-opacity duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
      mode="out-in">
      <div :key="location.title" class="flex flex-col gap-0.5 p-3.5 relative font-poppins min-w-80 lg:p-5 lg:gap-2">
        <Typography class="text-primary-100" as="h3" variant="header-5">{{ location.title }}</Typography>
        <Typography
          v-if="location.address"
          class="text-primary-60"
          as="span"
          variant="caption">
          {{ location.address }}
        </Typography>
        <CustomNuxtLink
          v-if="location.url"
          :to="location.url"
          class="group"
          @click.capture="$emit('click-location', $event, location)">
          <Link
            as="span"
            class="text-primary-100"
            variant="body"
            underline>
            {{ location.linkLabel ?? 'Bekijk deze locatie' }}
          </Link>
        </CustomNuxtLink>
      </div>
    </Transition>
  </article>
</template>

<script setup lang="ts">
import type { Location } from '@corporate/components/LocationCard/LocationCard.vue'
import { CloseIcon } from '@gro-up/ui/icons'
import { Image, Typography, Link, Button, CustomNuxtLink } from '@gro-up/ui/primitives'

defineProps<{
  location: Location
}>()

defineEmits(['close', 'click-location'])
</script>
